import { render, staticRenderFns } from "./AppBarUserMenu.vue?vue&type=template&id=3190b1e0&"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=ts&"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports